export default __webpack_public_path__ + "media/pro/delete-35665fdc.svg";